import { useSubscription } from '@apollo/client';
import React from 'react';

import { useApiClient } from '@eluve/api-client-provider';
import { Button, Icon, SimpleTooltip } from '@eluve/components';
import { useAppointmentContext } from '@eluve/frontend-appointment-hooks';
import { pendingTranscriptionFilesSubscriptions } from '@eluve/frontend-feature-appointment';
import { useTranslation } from '@eluve/i18n';

export const AppointmentRerunTranscriptionButton: React.FC = () => {
  const { t } = useTranslation();
  const { appointmentId, tenantId } = useAppointmentContext();

  const apiClient = useApiClient();

  const handleRerunTranscription = async () => {
    apiClient.transcription.batchTranscribe({
      params: {
        tenantId,
      },
      body: {
        appointmentId,
      },
    });
  };

  const { data: pendingFiles } = useSubscription(
    pendingTranscriptionFilesSubscriptions,
    {
      variables: { tenantId, id: appointmentId },
    },
  );

  const pendingFilesCount =
    pendingFiles?.appointmentsByPk?.appointmentFiles?.length ?? 0;

  return (
    <SimpleTooltip
      label={
        pendingFilesCount === 0
          ? t('appointmentPage.rerunTranscription.rerun')
          : t('appointmentPage.rerunTranscription.inProgress')
      }
    >
      <Button
        variant="outline"
        onClick={handleRerunTranscription}
        disabled={pendingFilesCount > 0}
      >
        <Icon name="RefreshCw" size="auto" />
      </Button>
    </SimpleTooltip>
  );
};
